import { anim, prog } from '../../../motion'
import { useCopy } from '../../i18n'
import { MARQUEE, QUOTE_LOGOS } from '../copy'
import { C, Shape } from '../shapes'

const WIN = [
  [0.02, 0.1, 0.3, 0.36],
  [0.36, 0.42, 0.62, 0.68],
  [0.68, 0.74]
]
const BULLETS = [
  ['circle', C.pink],
  ['square', C.green],
  ['tri', C.yellow]
]

/**
 * Drei Zitate aus den Fallstudien nacheinander, das Anführungszeichen ist aus
 * zwei Viertelkreisen gebaut. Unten laufen die Logos durch.
 */
export default function PlVoices() {
  const c = useCopy('stimmen')

  return (
    <div className='ap-voices'>
      <div className='ap-eyebrow ap-voices__eyebrow'>{c.eyebrow}</div>
      <div className='ap-voices__glyph' aria-hidden='true'>
        <Shape kind='quarter' color={C.yellow} size={64} />
        <Shape kind='quarter' color={C.yellow} size={64} />
      </div>

      <div className='ap-voices__stack'>
        {c.quotes.map((q, i) => {
          const [a, b, o1, o2] = WIN[i]
          return (
            <figure
              key={q.id}
              className='ap-voices__quote'
              style={anim({
                at: [a, b],
                out: o1 ? [o1, o2] : undefined,
                y: 50,
                oy: -50
              })}
            >
              <blockquote>{q.text}</blockquote>
              <figcaption>
                <img src={QUOTE_LOGOS[q.id]} alt='' />
                <span>
                  <strong>{q.author}</strong>
                  {q.role}
                </span>
              </figcaption>
            </figure>
          )
        })}
      </div>

      <div className='ap-voices__bullets' aria-hidden='true'>
        {BULLETS.map(([kind, color], i) => (
          <span
            key={kind}
            className='ap-voices__bullet'
            style={prog([WIN[i][0], WIN[i][1]])}
          >
            <Shape kind={kind} color={color} size={16} />
          </span>
        ))}
      </div>

      <div className='ap-voices__marquee'>
        <span className='ap-voices__trust'>{c.trust}</span>
        <div className='ap-voices__belt'>
          {[0, 1].map((k) => (
            <div key={k} className='ap-voices__logos' aria-hidden={k === 1}>
              {MARQUEE.map((src, i) => (
                <img key={i} src={src} alt='' />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
